import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-drop-down-panel',
  templateUrl: './drop-down-panel.component.html',
  styleUrls: ['./drop-down-panel.component.scss']
})
export class DropDownPanelComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isExpanded: boolean;

  private unsub$: Subject<void> = new Subject();
  
  constructor() { }

  public ngOnInit(): void {
    this.isExpanded = false;
    this.onToggle.asObservable().pipe(
      takeUntil(this.unsub$),
    ).subscribe((expanded) => this.isExpanded = expanded)
  }

  public ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }
}
